import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { CollectionCardItem } from 'entities/kyrgyzstan'
import {
  type DetailSearchParams,
  kyrgyzstanDetailContextStore,
} from 'entities/kyrgyzstan/model'

import type { KyrgyzstanCollectionPreset } from 'shared/api/kyrgyzstan/collections'

const getCollectionDetailSearchParams = (
  collectionPreset: KyrgyzstanCollectionPreset,
): DetailSearchParams | null => {
  const {
    start_date: startDate,
    end_date: endDate,
    visitors_count: visitorsCount,
  } = collectionPreset

  if (!startDate || !endDate || !visitorsCount) return null

  return {
    start_date: startDate,
    end_date: endDate,
    visitors_count: visitorsCount,
  }
}

export const useSelectCollectionItem = () => {
  const navigate = useNavigate()

  const selectCollectionItem = (item: CollectionCardItem) => {
    const detailSearchParams = getCollectionDetailSearchParams(
      item.collectionPreset,
    )

    kyrgyzstanDetailContextStore.setContext({
      parentId: item.id,
      detailSearchParams,
    })

    navigate(RoutingPaths.kyrgyzstan.detail.path(item.id))
  }

  return { selectCollectionItem }
}
